import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BackendService } from './backend.service';
import { QueryOptions, QueryResult } from '../components/common-dto/query.dto';
import { AttendeeDto } from '../dto/attendee.dto';

@Injectable({
  providedIn: 'root',
})
export class AttendeeService {
  constructor(
    private backend: BackendService,
    private http: HttpClient
  ) {}

  getAttendees(
    conferenceId: string,
    queryParams: QueryOptions
  ): Observable<QueryResult<AttendeeDto>> {
    return this.backend.getQuery<AttendeeDto>(
      `conference/${conferenceId}/attendees`,
      queryParams
    );
  }
}

